import React from 'react';

const TICKERS = [
  { label: 'SPX', value: '+0.42%', dir: 'up' },
  { label: 'NDX', value: '+0.68%', dir: 'up' },
  { label: 'DJI', value: '-0.11%', dir: 'down' },
  { label: 'QQQ', value: '+0.55%', dir: 'up' },
  { label: 'SOX', value: '+1.24%', dir: 'up' },
  { label: 'VIX', value: '14.2', dir: 'neutral' },
  { label: 'BTC', value: '+2.18%', dir: 'up' },
  { label: 'GOLD', value: '+0.31%', dir: 'up' },
  { label: 'NVDA', value: '+3.42%', dir: 'up' },
  { label: 'TSLA', value: '-1.05%', dir: 'down' },
];

const TickerMarquee = () => {
  const track = [...TICKERS, ...TICKERS];

  return (
    <div className="home-ticker" aria-label="Market tickers">
      <div className="home-ticker__status">
        <span className="home-ticker__pulse" />
        <span>LIVE</span>
        <span className="home-ticker__sep">·</span>
        <span>US Markets</span>
      </div>
      <div className="home-ticker__viewport">
        <div className="home-ticker__track">
          {track.map((t, idx) => (
            <div key={`${t.label}-${idx}`} className={`home-ticker__item home-ticker__item--${t.dir}`}>
              <span className="home-ticker__label">{t.label}</span>
              <span className="home-ticker__value">{t.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TickerMarquee;
